import React, {useEffect} from 'react'
import ReactDOM from 'react-dom/client'
import {Provider, useSelector, useDispatch} from 'react-redux'
import { useLocation, BrowserRouter, Routes, Route, Link, useNavigate, Navigate, Outlet} from 'react-router-dom'
import Layout from './pages/Layout'
import LoginPage from './pages/LoginPage'
import AdminHomePage from './pages/HomePage'
import SchoolPage from './pages/SchoolPage'
import CompanyPage from './pages/CompanyPage'
import UserPage from './pages/UserPage'
import CodePage from './pages/CodePage'
import StudentPage from './pages/StudentPage'
import LessonPage from './pages/LessonPage'
import SmstPage from './pages/SmstPage'
import LecturePage from './pages/LecturePage'
import RegiPage from './pages/RegiPage'
import RegiPage2 from './pages/RegiPage2'
import AttdncPage from './pages/AttdncPage'
import NoPage from './pages/NoPage'
import TestPage from './pages/TestPage'
import { Store } from './redux/store'
import { Persistor } from './redux/store'
import AdminDrawer from '@components/AdminDrawer'
import ManagerDrawer from './components/ManagerDrawer'
import EmptyDrawer from './components/EmptyDrawer'
import WelcomeDrawer from '@components/WelcomeDrawer'
import RegisterPage from './pages/RegisterPage'
import RootPage from './pages/RootPage'
import { PersistGate } from 'redux-persist/integration/react'
import ManagerLecturePage from '@pages/manager/manager-lecture.page'
import ManagerSmstPage from '@pages/manager/manager-smst.page'
import ManagerUserPage from '@pages/manager/manager-user.page'
import ManagerStudentPage from '@pages/manager/manager-student.page'
import ManagerCalendarPage from '@pages/manager/manager-calendar.page'
import ManagerManagerPage from '@pages/manager/manager-manager.page'
import CompanyManagerPage from '@pages/company/company-manager'
import ManagerIndexPage from '@pages/manager/manager-index.page'
import RegisterCompanyPage from '@pages/register/register-company.page'
import RegisterUserPage from '@pages/register/register-user.page'
import PublicDrawer from '@components/PublicDrawer'
import PublicDrawer2 from '@components/PublicDrawer2'
import AgmtPage from '@pages/AgmtPage'
import ProfileDrawer from '@components/ProfileDrawer'
import ProfileUserPage from '@pages/profile/profile-user.page'
import ProfileSchoolPage from '@pages/profile/profile-school.page'
import ProfileAgmtPage from '@pages/profile/profile-agmt.page'
import ManagerMessagePage from '@pages/manager/manager-message.page'
import ProfileEntrustPage from '@pages/profile/profile-entrust.page'
import WelcomeIndexPage from '@pages/welcome/welcome-index.page'
import WelcomeEmailPage from '@pages/welcome/welcome-email.page'
import ProfileCompanyPage from '@pages/profile/profile-company.page'
import ProfileCompanyManagerPage from '@pages/profile/profile-company.manager.page'
import ProfileCompanySchoolPage from '@pages/profile/profile-company.school.page'
import ProfileManagerPage from '@pages/profile/profile-manager.page'
import ProfileTeacherPage from '@pages/profile/profile-teacher.page'
import ProfileCompanyTeacherPage from '@pages/profile/profile-company.teacher.page'
import ProfileGdnPage from '@pages/profile/profile-gdn'
import ProfileDirectPage from '@pages/profile/profile-direct.page'
import ProfileDirectManagerPage from '@pages/profile/profile-direct.manager.page'
import ProfileDirectTeacherPage from '@pages/profile/profile-direct.teacher.page'
import TeacherDrawer from '@components/TeacherDrawer'
import GdnDrawer from '@components/GdnDrawer'
import CompanyConditionPage from '@pages/company.condition.page'
import CompanyAssignPage from '@pages/company.assgin.page'
import ManagerRegiPage from '@pages/manager/manager-regi.page'
import ManagerBillPage from '@pages/manager/manager-bill.page'
import ManagerNoticePage from '@pages/manager/manager-notice.page'
import ManagerAttdncPage from '@pages/manager/manager-attdnc.page'
import PublicFindIdPage from '@pages/public/public-find.id.page'
import PublicFindPasswordPage from '@pages/public/public-find.password.page'
import PublicNoticePage from '@pages/public/public-notice.page'
import PublicSurveyPage from '@pages/public/public-survey.page'
import ProfileLeavePage from '@pages/profile/profile-leave.page'
import LogoutPage from '@pages/LogoutPage'
import { createTheme, ThemeProvider, CssBaseline, Container, Typography } from '@mui/material'
import GdnLecturePage from '@pages/gdn/gdn-lecture.page'
import {appVersion} from '@util/appVersion'
import {setVersion} from '@redux/actions/versionActioin'
import {GlobalStyle as gs} from '@src/GlobalStyle'
import { CONTEXT_PATH } from '@util/constant'
import { isAdmin, isRepManager, isManager, isDirectManager } from '@util/helper'
import ManagerMessageSmsPage from '@pages/manager/manager-message-sms.page'
import DirectAssignPage from '@pages/direct.assign.page'
import ManagerDashboardPage from '@pages/manager/manager-dashboard.page'
import TestPerformancePage from '@pages/TestPerformance'
import TeacherCalendarPage from '@pages/teacher/teacher-calendar.page'
import TeacherLecturePage from '@pages/teacher/teacher-lecture.page'
import TeacherRegiPage from '@pages/teacher/teacher-regi.page'
import TeacherAttdncPage from '@pages/teacher/teacher-attdnc.page'
import TeacherNoticePage from '@pages/teacher/teacher-notice.page'
import TeacherSmstPage from '@pages/teacher/teacher-smst.page'
import TeacherMessagePage from '@pages/teacher/teacher-message.page'
import NaverCallback from 'oauth/NaverCallback'
import KakaoCallback from 'oauth/KakaoCallback'
import ManagerSurveyPage from '@pages/manager/manager-survey.page'
import ManagerVoucherPage from '@pages/manager/manager-voucher.page'
import RepairPage from '@pages/RepairPage'
import useDataVersionSync from './hooks/useDataVersionSync'
import GlobalSnackbar from '@components/GlobalSnackbar'
const theme = createTheme({
  typography: {
    fontSize: 14, // Adjust the base font size
  },
  components: {
    MuiTableCell: {
      defaultProps: {
        size: 'small', // Set the default size to "small"
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
        variant:'outlined',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant:'outlined',
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },
  },
  palette: {
    primary: {
      main:gs.colors.main,
      bar:gs.colors.bar,
    },
  },
  // spacing: 8,
  // You can add more customizations to the theme here
})


const VersionWatcher = () => {

  const version = useSelector((state) => state.versionReducer)
  const dispatch = useDispatch()
  const clearCache = () => {
    if('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name)
        })
      })
    }
  }


  useEffect(() => {
    console.log(`VersionWatcher mounted appVersion:${appVersion} version:${version}`)

    if(!version) {
      clearCache()
    }
    else {
      if(version !== appVersion) {
        clearCache()
      }
    }

    dispatch(setVersion(appVersion))

  }, [])

  return <React.Fragment></React.Fragment>
}


const AdminRoute = ({children}) => {
  const account = useSelector(state => state.accountReducer)
  return isAdmin(account) ? <Outlet /> : <Navigate to='/logout' />
}

const ManagerRoute = ({children}) => {
  const schola = useSelector((state) => state.scholaReducer)
  const account = useSelector(state => state.accountReducer)
  if(isManager(account, schola.id) ) {
    return <Outlet />
  }

  if(isRepManager(account, schola.id) ) {
    return <Outlet />
  }

  if(isAdmin(account)) {
    return <Outlet />
  }

  if(isDirectManager(account, schola.id) ) {
    return <Outlet />
  }
  
  alert('페이지에 대한 보기 권한이 없어 로그아웃 됩니다.')
  return <Navigate to='/logout' />
}

const App = () => {
  const account = useSelector(state => state.accountReducer)
  const versions = useDataVersionSync()
  useEffect(() => {
    console.log('App mounted')

  }, [])

  return (
    <ThemeProvider  theme={theme}>
      <GlobalSnackbar />
      <CssBaseline />
      <VersionWatcher />
      <BrowserRouter >
        <Routes>
          <Route path='/' element={<RootPage />} />
          <Route path='/register' element={<RegisterPage />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/logout' element={<LogoutPage />} />
          <Route path='/home' element={<NoPage />} />
          <Route path='/school' element={<SchoolPage />} />
          <Route path='/notice' element={<PublicNoticePage/>} />
          <Route path='/survey' element={<PublicSurveyPage/>} />
          <Route path='/repair/' element={<RepairPage/>} />
          <Route path='/repair/:message' element={<RepairPage/>} />
          <Route path='/admin' element={<AdminRoute/>}>
            <Route path='' element={<AdminDrawer />}>
              <Route index element={<DirectAssignPage />} />
              <Route path='direct/assign' element={<DirectAssignPage />} />
              <Route path='login' element={<LoginPage />} />
              <Route path='home' element={<AdminHomePage />} />
              <Route path='school' element={<SchoolPage />} />
              <Route path='company' element={<CompanyPage />} />
              <Route path='company/condition' element={<CompanyConditionPage />} />
              <Route path='company/assign' element={<CompanyAssignPage />} />
              <Route path='user' element={<UserPage />} />
              <Route path='student' element={<StudentPage />} />
              <Route path='smst' element={<SmstPage />} />
              <Route path='lesson' element={<LessonPage />} />
              <Route path='lecture' element={<LecturePage />} />
              <Route path='regi' element={<RegiPage />} />
              <Route path='regi2' element={<RegiPage2 />} />
              <Route path='attdnc' element={<AttdncPage />} />
              <Route path='code' element={<CodePage />} />
              <Route path='agmt' element={<AgmtPage />} />
              <Route path='*' element={<NoPage />} />
            </Route>
          </Route>

          <Route path='/manager' element={<ManagerRoute/>}>
            <Route path='' element={<ManagerDrawer />}>
              <Route index element={<ManagerDashboardPage/>} />
              <Route path='login' element={<LoginPage />} />
              <Route path='index' element={<ManagerIndexPage />} />
              <Route path='dashboard' element={<ManagerDashboardPage/>} />
              <Route path='student' element={<ManagerStudentPage />} />
              <Route path='student/:more' element={<ManagerStudentPage />} />
              <Route path='smst' element={<ManagerSmstPage />} />
              <Route path='smst/:more' element={<ManagerSmstPage />} />
              <Route path='lesson' element={<LessonPage />} />
              <Route path='lecture' element={<ManagerLecturePage />} />
              <Route path='lecture/:more' element={<ManagerLecturePage />} />
              <Route path='regi' element={<ManagerRegiPage />} />
              <Route path='regi/:more' element={<ManagerRegiPage />} />
              <Route path='attdnc' element={<ManagerAttdncPage />} />
              <Route path='attdnc/:more' element={<ManagerAttdncPage />} />
              <Route path='notice' element={<ManagerNoticePage />} />
              <Route path='notice/:more' element={<ManagerNoticePage />} />
              <Route path='survey' element={<ManagerSurveyPage />} />
              <Route path='survey/:more' element={<ManagerSurveyPage />} />
              <Route path='voucher' element={<ManagerVoucherPage />} />
              <Route path='voucher/:more' element={<ManagerVoucherPage />} />
              <Route path='bill' element={<ManagerBillPage />} />
              <Route path='regi2' element={<RegiPage2 />} />
              <Route path='code' element={<CodePage />} />
              <Route path='schedule' element={<ManagerCalendarPage />} />
              <Route path='schedule/:more' element={<ManagerCalendarPage />} />
              <Route path='user/:rltnCode' element={<ManagerUserPage />} />
              <Route path='manager' element={<ManagerManagerPage />} />
              <Route path='message' element={<ManagerMessagePage />} />
              <Route path='message/:more' element={<ManagerMessagePage />} />
              <Route path='message/sms' element={<ManagerMessageSmsPage/>} />
              <Route path='test' element={<TestPage />} />
              <Route path='*' element={<NoPage />} />
              <Route path='manager2'>
                <Route path='code' element={<CodePage />} />
              </Route>
            </Route>
          </Route>

          <Route path='/teacher' element={<TeacherDrawer />}>
            <Route index element={<TeacherAttdncPage />} />
            <Route path='login' element={<LoginPage />} />
            <Route path='index' element={<ManagerIndexPage />} />
            <Route path='smst' element={<TeacherSmstPage />} />
            <Route path='lecture' element={<TeacherLecturePage />} />
            <Route path='regi' element={<TeacherRegiPage />} />
            <Route path='attdnc' element={<TeacherAttdncPage />} />
            <Route path='schedule' element={<TeacherCalendarPage />} />
            <Route path='notice' element={<TeacherNoticePage />} />
            <Route path='message' element={<TeacherMessagePage />} />
            <Route path='*' element={<NoPage />} />
          </Route>

          <Route path='/oauth' element={<><Outlet /></>}>
            <Route path='naver/callback' element={<NaverCallback />} />
            <Route path='kakao/callback' element={<KakaoCallback />} />
            <Route path='*' element={<NoPage />} />
          </Route>
              
          <Route path='/gdn' element={<GdnDrawer />}>
            <Route index element={<ManagerCalendarPage />} />
            <Route path='login' element={<LoginPage />} />
            <Route path='index' element={<ManagerIndexPage />} />
            <Route path='student' element={<ManagerStudentPage />} />
            <Route path='smst' element={<ManagerSmstPage />} />
            <Route path='lesson' element={<LessonPage />} />
            <Route path='lecture' element={<GdnLecturePage />} />
            <Route path='regi' element={<ManagerRegiPage />} />
            <Route path='regi2' element={<RegiPage2 />} />
            <Route path='attdnc' element={<AttdncPage />} />
            <Route path='code' element={<CodePage />} />
            <Route path='schedule' element={<ManagerCalendarPage />} />
            <Route path='user/:rltnCode' element={<ManagerUserPage />} />
            <Route path='manager' element={<ManagerManagerPage />} />
            <Route path='message' element={<ManagerMessagePage />} />
            <Route path='*' element={<NoPage />} />
            <Route path='manager2'>
              <Route path='code' element={<CodePage />} />
            </Route>
          </Route>
          <Route path='/company' element={<EmptyDrawer />}>
            <Route index element={<CompanyManagerPage />} />
            <Route path='manager' element={<CompanyManagerPage />} />
          </Route>
          <Route path='/register' element={<PublicDrawer />}>
            <Route index element={<RegisterCompanyPage />} />
            <Route path='user' element={<RegisterUserPage />} />
            <Route path='company' element={<RegisterCompanyPage />} />
          </Route>
          <Route path='/public' element={<PublicDrawer />}>
            <Route path='find/id' element={<PublicFindIdPage />} />
            <Route path='find/password' element={<PublicFindPasswordPage />} />
            <Route path='test/performance' element={<TestPerformancePage/>} />
          </Route>
          <Route path='/public2' element={<PublicDrawer2 />}>
            <Route path='notice/:noticeId' element={<PublicNoticePage/>} />
            <Route path='survey/:encSurveyId' element={<PublicSurveyPage/>} />
          </Route>
          <Route path='/profile' element={<ProfileDrawer />}>
            <Route index element={<ProfileUserPage />} />
            <Route path='user' element={<ProfileUserPage />} />
            <Route path='company' element={<ProfileCompanyPage />} />
            <Route path='company/:more' element={<ProfileCompanyPage />} />
            <Route path='company/school' element={<ProfileCompanySchoolPage />} />
            <Route path='company/school/:more' element={<ProfileCompanySchoolPage />} />
            <Route path='company/manager' element={<ProfileCompanyManagerPage />} />
            <Route path='company/manager/:more' element={<ProfileCompanyManagerPage />} />
            <Route path='company/teacher' element={<ProfileCompanyTeacherPage />} />
            <Route path='company/teacher/:more' element={<ProfileCompanyTeacherPage />} />
            <Route path='direct' element={<ProfileDirectPage/>} />
            <Route path='direct/:more' element={<ProfileDirectPage/>} />
            <Route path='direct/manager' element={<ProfileDirectManagerPage />} />
            <Route path='direct/teacher' element={<ProfileDirectTeacherPage />} />
            <Route path='manager' element={<ProfileManagerPage />} />
            <Route path='manager/:more' element={<ProfileManagerPage />} />
            <Route path='teacher' element={<ProfileTeacherPage />} />
            <Route path='teacher/:more' element={<ProfileTeacherPage />} />
            <Route path='gdn' element={<ProfileGdnPage />} />
            <Route path='gdn/:more' element={<ProfileGdnPage />} />
            <Route path='agmt' element={<ProfileAgmtPage />} />
            <Route path='leave' element={<ProfileLeavePage/>} />
            <Route path='entrust' element={<ProfileEntrustPage />} />
            <Route path='bcompany' element={<ProfileManagerPage />} />
          </Route>
          <Route path='/welcome' element={<WelcomeDrawer />}>
            <Route index element={<WelcomeIndexPage />} />
            <Route path='index' element={<WelcomeIndexPage />} />
            <Route path='manager' element={<ManagerIndexPage />} />
            <Route path='email/:emailCertId/:certNum' element={<WelcomeEmailPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
